var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiderbarIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.6797H20V20H0V16.6797ZM15.8203 9.57031C16.9401 10.7943 17.5 11.7708 17.5 12.5C17.5 12.9427 17.3307 13.3333 16.9922 13.6719C16.6536 14.0104 16.263 14.1797 15.8203 14.1797C15.3776 14.1797 14.987 14.0104 14.6484 13.6719C14.3359 13.3333 14.1797 12.9427 14.1797 12.5C14.1797 12.1875 14.3099 11.7839 14.5703 11.2891C14.8568 10.7943 15.1302 10.3906 15.3906 10.0781L15.8203 9.57031ZM4.33594 8.32031H12.3438L8.32031 4.33594L4.33594 8.32031ZM13.7891 7.46094C14.0495 7.72135 14.1797 8.02083 14.1797 8.35938C14.1797 8.69792 14.0495 8.98438 13.7891 9.21875L9.21875 13.7891C8.95833 14.0495 8.65885 14.1797 8.32031 14.1797C8.00781 14.1797 7.72135 14.0495 7.46094 13.7891L2.85156 9.21875C2.61719 8.98438 2.5 8.6849 2.5 8.32031C2.5 7.98177 2.61719 7.69531 2.85156 7.46094L7.14844 3.16406L5.15625 1.17188L6.36719 0L13.7891 7.46094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiderbarIcon1);
export default __webpack_public_path__ + "static/media/siderbar-icon1.40f783dc7b19428c8656c5ed73130627.svg";
export { ForwardRef as ReactComponent };